import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

interface RecommendationModalProps {
  show: boolean;
  onClose: () => void;
}

const RecommendationModal: React.FC<RecommendationModalProps> = ({ show, onClose }) => {
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate('/dashboard', { replace: true });
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} centered size="lg" backdrop="static" className="rounded-4">
      <Modal.Body className="text-center p-4">
        <h5 className="fw-bold mb-3">📂 Recommendation</h5>
        <p className="text-muted mb-4">
          We recommend adding a portfolio to highlight your projects, accomplishments, and story. A
          complete SkipScreen profile increases your chances of attracting recruiters.
        </p>

        <div className="d-flex justify-content-center gap-3">
          <Button
            type="button"
            variant="success"
            className="px-4 rounded-pill"
            onClick={handleGoToDashboard}
          >
            Go to Dashboard
          </Button>
          {/* <Button
            type="button"
            variant="outline-secondary"
            className="px-4 rounded-pill"
            onClick={onClose}
          >
            Close
          </Button> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RecommendationModal;
